import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'filter',
  init() {
    const FilterPage = Vue.component('filter-page', () =>
      import(/* webpackChunkName: "filter-page" */ './FilterPage.vue')
    )
    newVue({
      render: h => h(FilterPage),
      mount: '.js-vue-filter-page',
      stores: ['filter'],
    })
  },
})
